.bold {
  font-weight: 700;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0 13px;
  margin-bottom: 20px;
}

.footer {
  display: flex;
  flex-direction: column;
  padding: 0 13px 13px;
}
